import { DashboardLayout } from "@/components/Dashboard/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Zap, Link2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Integrations = () => {
  const { t } = useLanguage();
  
  const integrations = [
    {
      key: "salesforce",
      name: t.integrations.salesforce.name,
      description: t.integrations.salesforce.description,
      category: "CRM",
      status: "available",
    },
    {
      key: "sap",
      name: t.integrations.sap.name,
      description: t.integrations.sap.description,
      category: "ERP",
      status: "available",
    },
    {
      key: "hubspot",
      name: t.integrations.hubspot.name,
      description: t.integrations.hubspot.description,
      category: "CRM",
      status: "available",
    },
    {
      key: "netsuite",
      name: t.integrations.netsuite.name,
      description: t.integrations.netsuite.description,
      category: "ERP",
      status: "available",
    },
    {
      key: "dynamics",
      name: t.integrations.dynamics.name,
      description: t.integrations.dynamics.description,
      category: "ERP",
      status: "coming",
    },
    {
      key: "zoho",
      name: t.integrations.zoho.name,
      description: t.integrations.zoho.description,
      category: "CRM",
      status: "coming",
    },
  ];
  
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-3xl font-bold text-foreground">{t.integrations.title}</h2>
          <p className="text-muted-foreground mt-1">
            {t.integrations.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {integrations.map((integration) => (
            <Card
              key={integration.key}
              className="p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="p-3 rounded-xl bg-accent/10">
                  <Zap className="w-6 h-6 text-accent" />
                </div>
                <Badge variant={integration.status === "available" ? "default" : "secondary"}>
                  {integration.status === "available" ? t.integrations.available : t.integrations.comingSoon}
                </Badge>
              </div>

              <h3 className="text-lg font-semibold text-foreground mb-2">
                {integration.name}
              </h3>
              <p className="text-sm text-muted-foreground mb-4">
                {integration.description}
              </p>

              <div className="flex items-center justify-between">
                <Badge variant="outline">{integration.category}</Badge>
                <Button
                  size="sm"
                  disabled={integration.status !== "available"}
                  className="bg-primary hover:bg-primary/90"
                >
                  <Link2 className="w-4 h-4 mr-2" />
                  {t.integrations.connect}
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Integrations;
